import { memo } from "react";
import { PayrollRecordView } from "./PayrollRecordView";
import { PayrollActionLinks } from "./PayrollActionLinks";

export const PayrollInspectionRecordView = memo(() => {
  return (
    <PayrollRecordView
      className="mb-4"
      actions={[
        <PayrollActionLinks
          inspectOptions={{ isBold: true, isDisabled: true }}
        />,
      ]}
    />
  );
});

PayrollInspectionRecordView.displayName = "PayrollInspectionRecordView";
